import { useMemo, useState } from "react";
import { CheckCircle2 } from "lucide-react";

const SERVICES = {
  carwash: ["Standart yuma", "Premium yuma", "Salon təmizliyi"],
  salon: ["Saç kəsimi", "Manikür", "Makiyaj"],
  clinic: ["Müayinə", "Diş təmizliyi", "Konsultasiya"],
  restaurant: ["Masa — 2 nəfər", "Masa — 4 nəfər", "VIP otaq"],
};
const TIMES = ["10:00", "11:30", "14:00", "16:30"];
const MONTHS = ["YAN", "FEV", "MAR", "APR", "MAY", "İYN", "İYL", "AVQ", "SEN", "OKT", "NOY", "DEK"];

const Chip = ({ active, onClick, children, testid }) => (
  <button onClick={onClick} data-active={active} data-testid={testid} className="adv-option px-3 py-2.5 text-sm font-medium text-center">
    {children}
  </button>
);

export const BookingDemo = ({ businessKey }) => {
  const services = SERVICES[businessKey] || SERVICES.carwash;
  const dates = useMemo(() => [1, 2, 3].map((d) => {
    const x = new Date(Date.now() + d * 86400000);
    return `${x.getDate()} ${MONTHS[x.getMonth()]}`;
  }), []);
  const [sel, setSel] = useState({ service: null, date: null, time: null });
  const [done, setDone] = useState(false);
  const ready = sel.service && sel.date && sel.time;

  if (done)
    return (
      <div className="text-center py-6" data-testid="booking-demo-success">
        <CheckCircle2 className="h-12 w-12 text-emerald-400 mx-auto" />
        <div className="font-display text-lg font-semibold mt-3">Demo rezervasiya yaradıldı</div>
        <p className="text-sm text-[#a9a398] mt-1">{sel.service} · {sel.date} · {sel.time}</p>
        <button className="adv-btn-ghost mt-4 text-sm" onClick={() => { setDone(false); setSel({ service: null, date: null, time: null }); }} data-testid="booking-demo-reset">
          Yenidən sına
        </button>
      </div>
    );

  return (
    <div className="space-y-4" data-testid="booking-demo">
      <div>
        <div className="text-sm font-semibold mb-2">1. Xidməti seçin</div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          {services.map((s, i) => <Chip key={s} active={sel.service === s} onClick={() => setSel({ ...sel, service: s })} testid={`booking-service-${i}`}>{s}</Chip>)}
        </div>
      </div>
      <div>
        <div className="text-sm font-semibold mb-2">2. Tarix</div>
        <div className="grid grid-cols-3 gap-2">
          {dates.map((d, i) => <Chip key={d} active={sel.date === d} onClick={() => setSel({ ...sel, date: d })} testid={`booking-date-${i}`}>{d}</Chip>)}
        </div>
      </div>
      <div>
        <div className="text-sm font-semibold mb-2">3. Saat</div>
        <div className="grid grid-cols-4 gap-2">
          {TIMES.map((t, i) => <Chip key={t} active={sel.time === t} onClick={() => setSel({ ...sel, time: t })} testid={`booking-time-${i}`}>{t}</Chip>)}
        </div>
      </div>
      <button className="adv-btn w-full" disabled={!ready} onClick={() => setDone(true)} data-testid="booking-demo-submit">
        Rezervasiya et
      </button>
    </div>
  );
};
